import { SCROLL_TO_QUERY_PARAM } from "./constants";

const getSearchWithoutScrollToQuery = (search = "") => {
  const nextSearch = search
    .replace(/^\?/, "")
    .split("&")
    .filter(Boolean)
    .filter(queryPart => !queryPart.startsWith(`${SCROLL_TO_QUERY_PARAM}=`))
    .join("&");

  return nextSearch ? `?${nextSearch}` : "";
};

const getNormalizedPathname = pathname => {
  if (typeof pathname !== "string" || pathname.length === 0) {
    return "/";
  }

  return pathname.replace(/^\/{2,}/, "/");
};

const removeScrollToQuery = history => {
  const location = {
    ...history.location,
    pathname: getNormalizedPathname(history.location.pathname),
    search: getSearchWithoutScrollToQuery(history.location.search)
  };

  history.replace(location);
};

export default removeScrollToQuery;
